import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import {Link, Redirect} from 'react-router-dom';
import {SketchPicker} from 'react-color';
import Toggle from 'react-toggle';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import getLocale from '../../i18n/getLocale';

class ScheduleInitialsAdd extends Component {
  // constructor
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: 0,
      name: '',
      fullname: '',
      description: '',
      background: '#ffffff',
      color: '#000000',
      diaria: 0,
      is_crew: 0,
      training: 0,
      trip_extra: 0,
      official: 0,
      apresentacao: 0,
      vacant: 0,
      vacation: 0,
      daily_planning: 0,
      stand_by: 0,
      reserve: 0,
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);
    this.handleChangeCompleteColor = this.handleChangeCompleteColor.bind(this);
    this.handleChangeCompleteBackground = this.handleChangeCompleteBackground.bind(this);

    this.locale = getLocale();

    this.add = this.add.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleChangeCompleteColor (color, event) {
    var color = color.hex;
    this.setState({ color: color });
  };
  handleChangeCompleteBackground (color, event) {
    var color = color.hex;
    this.setState({ background: color });
  };

  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }
  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }
  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }
  componentDidMount () {
    this.refs.request_api.header();
  }

  add(event) {
    event.preventDefault();
    var datasave = {
      name: this.state.name,
      fullname: this.state.fullname,
      diaria: this.state.diaria,
      is_crew: this.state.is_crew,
      training: this.state.training,
      trip_extra: this.state.trip_extra,
      official: this.state.official,
      apresentacao: this.state.apresentacao,
      vacant: this.state.vacant,
      vacation: this.state.vacation,
      daily_planning: this.state.daily_planning,
      stand_by: this.state.stand_by,
      reserve: this.state.reserve,
      description: this.state.description,
      background: this.state.background,
      color: this.state.color,
    };
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/sigla', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          var url = '/sigla/editar/' + responseJson.data.id;
          var storage = {
            alert_message: responseJson.message,
            alert_type: responseJson.status,
          };
          localStorage.setItem("verify_message", JSON.stringify(storage));
          self.setState({redirect_url: url});
        }
          self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.Siglas.AdicionarSigla.titulo}</h3>
      <Link to="/siglas" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> {this.locale.general.voltar}</Link>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.add}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Siglas.AdicionarSigla.formulario.Sigla}:</label>
              <input type="text" name="name" className="form-control" placeholder={this.locale.Siglas.AdicionarSigla.formulario.placeholder.Sigla} value={this.state.name} onChange={this.handleChange.bind(this, 'name')} />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Siglas.AdicionarSigla.formulario.NomeInteiro}:</label>
              <input type="text" name="fullname" className="form-control" placeholder={this.locale.Siglas.AdicionarSigla.formulario.placeholder.NomeInteiro} value={this.state.fullname} onChange={this.handleChange.bind(this, 'fullname')} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Siglas.AdicionarSigla.formulario.Descricao}:</label>
              <input type="text" name="description" className="form-control" value={this.state.description} onChange={this.handleChange.bind(this, 'description')} />
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-group">
              <label>{this.locale.Siglas.AdicionarSigla.formulario.ContaDiaria}?</label>
              <br/>
              <Toggle
                checked={this.state.diaria}
                aria-label='No label tag'
                name="diaria"
                onChange={this.handleToggleChange.bind(this, 'diaria')} />
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-group">
              <label>{this.locale.Siglas.AdicionarSigla.formulario.TripulaAeronave}?</label>
              <br/>
              <Toggle
                checked={this.state.is_crew}
                aria-label='No label tag'
                name="is_crew"
                onChange={this.handleToggleChange.bind(this, 'is_crew')} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.Siglas.AdicionarSigla.formulario.SiglaDeTreinamento}?</label>
              <br/>
              <Toggle
                checked={this.state.training}
                aria-label='No label tag'
                name="training"
                onChange={this.handleToggleChange.bind(this, 'training')} />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.Siglas.AdicionarSigla.formulario.SiglaDeTripulacaoExtra}?</label>
              <br/>
              <Toggle
                checked={this.state.trip_extra}
                aria-label='No label tag'
                name="trip_extra"
                onChange={this.handleToggleChange.bind(this, 'trip_extra')} />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.Siglas.AdicionarSigla.formulario.SiglaDeFerias}?</label>
              <br/>
              <Toggle
                checked={this.state.vacation}
                aria-label='No label tag'
                name="vacation"
                onChange={this.handleToggleChange.bind(this, 'vacation')} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.Siglas.AdicionarSigla.formulario.SiglaDeFolga}?</label>
              <br/>
              <Toggle
                checked={this.state.vacant}
                aria-label='No label tag'
                name="vacant"
                onChange={this.handleToggleChange.bind(this, 'vacant')} />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.Siglas.AdicionarSigla.formulario.SiglaDeApresentação}?</label>
              <br/>
              <Toggle
                checked={this.state.apresentacao}
                aria-label='No label tag'
                name="apresentacao"
                onChange={this.handleToggleChange.bind(this, 'apresentacao')} />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.Siglas.AdicionarSigla.formulario.SiglaOficialASerUsadaEmEscala}?</label>
              <br/>
              <Toggle
                checked={this.state.official}
                aria-label='No label tag'
                name="official"
                onChange={this.handleToggleChange.bind(this, 'official')} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.Siglas.AdicionarSigla.formulario.SiglaOficialASerUsadaNaEscalaDiaria}?</label>
              <br/>
              <Toggle
                checked={this.state.daily_planning}
                aria-label='No label tag'
                name="daily_planning"
                onChange={this.handleToggleChange.bind(this, 'daily_planning')} />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.Siglas.AdicionarSigla.formulario.SiglaDeSobreaviso}?</label>
              <br/>
              <Toggle
                checked={this.state.stand_by}
                aria-label='No label tag'
                name="stand_by"
                onChange={this.handleToggleChange.bind(this, 'stand_by')} />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.Siglas.AdicionarSigla.formulario.SiglaDeReserva}?</label>
              <br/>
              <Toggle
                checked={this.state.reserve}
                aria-label='No label tag'
                name="reserve"
                onChange={this.handleToggleChange.bind(this, 'reserve')} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Siglas.AdicionarSigla.formulario.SelecioneACorDeFundo}:</label>
              <br/>
              <SketchPicker
                color={this.state.background}
                onChangeComplete={this.handleChangeCompleteBackground}
                width={300}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Siglas.AdicionarSigla.formulario.SelecioneACorDaFonte}:</label>
              <br/>
              <SketchPicker
                color={this.state.color}
                onChangeComplete={this.handleChangeCompleteColor}
                width={300}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.Siglas.AdicionarSigla.formulario.botaoAdicionarSigla}</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
    );
  }
}

export default ScheduleInitialsAdd;



// WEBPACK FOOTER //
// ./src/Components/ScheduleInitials/ScheduleInitialsAdd.js